$shm_hitalama_map_pane_tool $mol_view
	Map_page $shm_hitalama_map_page
	mode \
	client_pos_to_pane_pos* null
	to_real_pos* null
	zoom? 1
	pan? $mol_vector_2d<number> /
		0
		0
	event_start? null
	event_move? null
	event_end? null
	draft_start? null
	draft_end? null
	draft_line? null
	draft_frozen? false
	auto /
		<= draft_frozen?
	style *
		^
		pointerEvents <= pointer_events \none
	sub <= tool_sub /
		<= Svg $mol_view
			dom_name \svg
			dom_name_space \http://www.w3.org/2000/svg
			attr *
				^
				viewBox <= view_box \0 0 1 1
				preserveAspectRatio \none
			sub <= draft_views /
				<= Stroke $mol_view
					dom_name \polyline
					dom_name_space \http://www.w3.org/2000/svg
					attr *
						^
						points <= stroke_points \
						fill \none
						stroke <= stroke_color \#808080
						stroke-width <= stroke_width \4
						stroke-linecap \round
						stroke-linejoin \round
				<= Rect $mol_view
					dom_name \rect
					dom_name_space \http://www.w3.org/2000/svg
					attr *
						^
						x <= shape_x \0
						y <= shape_y \0
						width <= shape_width \0
						height <= shape_height \0
						fill <= shape_fill \transparent
						stroke <= stroke_color \#808080
						stroke-width <= stroke_width \4
				<= Circle $mol_view
					dom_name \ellipse
					dom_name_space \http://www.w3.org/2000/svg
					attr *
						^
						cx <= circle_cx \0
						cy <= circle_cy \0
						rx <= circle_rx \0
						ry <= circle_ry \0
						fill <= shape_fill \transparent
						stroke <= stroke_color \#808080
						stroke-width <= stroke_width \4
